import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

// Async thunk to fetch progress for a specific subject
export const fetchProgress = createAsyncThunk(
  "progress/fetchProgress",
  async (subject, thunkAPI) => {
    try {
      if (!subject || subject === "undefined") return {};
      const res = await axiosInstance.get(`/progress/${subject}`);
      return res.data || {};
    } catch (error) {
      console.error("Error fetching progress:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data?.detail || error.message || "Failed to fetch progress"
      );
    }
  }
);

// Async thunk to toggle completion progress for a single lesson
export const toggleProgress = createAsyncThunk(
  "progress/toggleProgress",
  async ({ subject, contentId, completed }, thunkAPI) => {
    try {
      const res = await axiosInstance.post("/progress/toggle", {
        subject,
        content_id: contentId,
        completed
      });
      return res.data || {};
    } catch (error) {
      console.error("Error toggling progress:", error);
      return thunkAPI.rejectWithValue(
        error.response?.data?.detail || error.message || "Failed to toggle progress"
      );
    }
  }
);

const progressSlice = createSlice({
  name: "progress",
  initialState: {
    progressMap: {}, // Maps contentId string to boolean completion status
    loading: false,
    error: null,
  },
  reducers: {
    clearProgress(state) {
      state.progressMap = {};
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // fetchProgress
      .addCase(fetchProgress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProgress.fulfilled, (state, action) => {
        state.loading = false;
        state.progressMap = action.payload;
      })
      .addCase(fetchProgress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // toggleProgress
      .addCase(toggleProgress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(toggleProgress.fulfilled, (state, action) => {
        state.loading = false;
        state.progressMap = action.payload;
      })
      .addCase(toggleProgress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearProgress } = progressSlice.actions;
export default progressSlice.reducer;
